import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';

const STORAGE_KEY = 'tabys-music-v3';
const VOLUME = 0.2;

const MusicContext = createContext(null);

export function MusicProvider({ children }) {
  const audioRef = useRef(null);
  const [muted, setMutedState] = useState(true);
  const armedRef = useRef(false);

  useEffect(() => {
    const audio = new Audio(`${process.env.PUBLIC_URL}/sounds/bg-in-motion.mp3`);
    audio.loop = true;
    audio.preload = 'auto';
    audio.volume = VOLUME;
    audioRef.current = audio;

    return () => {
      audio.pause();
      audio.removeAttribute('src');
      audio.load();
      audioRef.current = null;
    };
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ muted }));
    const audio = audioRef.current;
    if (!audio) return;
    if (muted || !armedRef.current) {
      audio.pause();
      return;
    }
    audio.volume = VOLUME;
    audio.play().catch(() => {});
  }, [muted]);

  const toggle = useCallback(() => {
    armedRef.current = true;
    setMutedState((prev) => !prev);
  }, []);

  const value = useMemo(() => ({ muted, toggle }), [muted, toggle]);

  return <MusicContext.Provider value={value}>{children}</MusicContext.Provider>;
}

export function useMusic() {
  const ctx = useContext(MusicContext);
  if (!ctx) throw new Error('useMusic must be used within MusicProvider');
  return ctx;
}
